import { OrdersModel, PaymentConfigModel } from '@pukka/api';
import { Button, Text, Tooltip } from '@pukka/ui-components';

import { showRefundModal } from './TransactionRefund.state';

interface RefundButtonProps {
  readonly orderDetail: OrdersModel.OrderDetail | null;
  readonly paymentMethods: PaymentConfigModel.PaymentMethod[];
  readonly onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

function RefundButton({ orderDetail, paymentMethods, onClick = showRefundModal }: RefundButtonProps) {
  const orderPaymentType = orderDetail?.payment_type;
  const paymentMethodTransaction =
    orderDetail && paymentMethods.length > 0 && paymentMethods.find((paymentMethod) => paymentMethod.code === orderPaymentType);
  const showRefundButton = orderDetail?.refundable && !!paymentMethodTransaction;
  const enableRefundButton = showRefundButton && paymentMethodTransaction.isRefundable;

  // eslint-disable-next-line no-nested-ternary
  return showRefundButton ? (
    orderPaymentType === 'card' ? (
      <Tooltip
        trigger={
          <Button variant="secondary" size="m" disabled>
            Issue Refund
          </Button>
        }
      >
        <Text color="white" variant="caption-1">
          Card transaction can only be refunded from the mobile device
        </Text>
      </Tooltip>
    ) : (
      <Button variant="secondary" size="m" disabled={!enableRefundButton} onClick={onClick}>
        Issue Refund
      </Button>
    )
  ) : null;
}

export { RefundButton };
